<!-- HIDDEN APP DRAWER : scrolls up and revealing user info details or any other injected content -->
<div class="eui-app-sidebar-drawer-content">
    <ng-content></ng-content>
</div>
